<section class="course-page">
    <div class="container content-box module-content">
      <ng-container *ngIf="page && !youtubeContent && !videoJsContent">
        <h2 *ngIf="page.title">{{page.title}}</h2>
        <div class="page-content" [injectHTML]="pageContent"></div>
      </ng-container>

      <!-- Youtube -->
      <ng-container *ngIf="page && youtubeContent">
        <h2 *ngIf="page.title">{{page.title}}</h2>

        <div *ngIf="pageContentBeforeVideo" class="page-content before-video" [injectHTML]="pageContentBeforeVideo"></div>

        <div class="clearfix">
          <app-youtube-player #childVideo
            [src]="youtubeParams.src"
            [autoplay]="youtubeParams.autoplay"
            [width]="youtubeParams.width"
            [height]="youtubeParams.height"
            [style]="youtubeParams.style"
          ></app-youtube-player>
        </div>

        <div *ngIf="pageContentAfterVideo" class="page-content after-video" [injectHTML]="pageContentAfterVideo"></div>
      </ng-container>

      <!-- VideoJs -->
      <ng-container *ngIf="page && videoJsContent">
        <h2 *ngIf="page.title">{{page.title}}</h2>

        <div *ngIf="pageContentBeforeVideo" class="page-content before-video" [injectHTML]="pageContentBeforeVideo"></div>

        <div class="clearfix">
          <app-video-js-player #childVideo
            [src]="videoJsParams.src"
            [type]="videoJsParams.type"
            [poster]="videoJsParams.poster"
            [captions]="videoJsParams.captions"
            [autoplay]="videoJsParams.autoplay"
            [width]="videoJsParams.width"
            [height]="videoJsParams.height"
            [style]="videoJsParams.style"
            [preventFastForward]="delay && video ? !video.isCompleted : false"
            [useHlsStreaming]="true"
          ></app-video-js-player>
        </div>

        <div *ngIf="pageContentAfterVideo" class="page-content after-video" [injectHTML]="pageContentAfterVideo"></div>
      </ng-container>
    </div>

    <div class="container navigate-buttons">
        <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
        <button type="button" class="btn waves-dark w-25" *ngIf="!video" (click)="goNext($event)" [delay-click]="pageDelay" [delay-tooltip]="true">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
        <div *ngIf="debug && video">{{video.duration | number}} | {{video.speed | number}} | {{video.isCompleted}}</div>
        <button type="button" class="btn waves-dark w-25" *ngIf="video" (click)="goNext($event)" [delay-click]="pageDelay" [delay-until]="delay ? video.isCompleted : true" delay-tooltip="Watch the whole video to the end first.">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
    </div>
</section>
